/**
 * OHAT評価結果画面（グラフ・結果テーブル）で共有する配色。
 * デザイン指定に合わせて1箇所で管理する。
 */

/** 「今回」のオレンジ（レーダーチャートと結果テーブルで共通） */
const THIS_TIME_ORANGE = '#E3672A';

export const RESULT_COLORS = {
  /** 今回（レーダーチャートの「今回」と同じオレンジ） */
  thisTime: THIS_TIME_ORANGE,
  /** 前回 */
  previous: '#808080',
  /** 初回（グラフの線・ドット） */
  first: '#B3B3B3',
  /** 初回（テーブルのラベル文字） */
  firstLabel: '#8c8c8c',
  /** グラフのグリッド線 */
  grid: '#E5E5E5',
  /** 健康的セルの背景 */
  cellFine: '#EAF2F8',
  /** やや病的セルの背景 */
  cellBad: '#FDF7E3',
  /** 病的セルの背景 */
  cellDiseased: '#FBEDEC',
  /** ステータスセルの文字色 */
  cellText: '#262626',
  /** レーダーチャート専用。グレー基調は見にくいとのレビューにより元の配色に戻した（「今回」はテーブルと共通、前回・初回はテーブルと別配色） */
  chart: {
    /** 今回 */
    thisTime: THIS_TIME_ORANGE,
    /** 前回 */
    previous: '#09814A',
    /** 初回 */
    first: '#03007E',
    /** 半径軸の目盛り文字 */
    axisTick: '#8884d8',
  },
} as const;
